import React from "react";
import nextId from "react-id-generator";

import { Overrides } from "baseui/overrides";

import FormControl from "../../inputs/form_control";
import PromptWithSecondaryText from "./shared_components/prompt_with_secondary_text";
import { useConstructAriaLabel } from "./use_construct_aria_label";
import { Datepicker, DatepickerProps } from "../../date_and_time/datepicker";
import { Theme } from "../../../../styling/baseui_theme";
import { DatepickerOverrides } from "baseui/datepicker";

const DATEPICKER_NAMESPACE = "datepicker-input";
export interface DatepickerQuestionWrapperProps extends Omit<DatepickerProps, "inputAriaLabel"> {
  supplementalQuestionPrompt: string;
  secondaryText?: string;
  label?: string;
  optional: boolean;
  placeholder?: string;
  errorMessage?: string;
  overrides?: Overrides<DatepickerOverrides>;
}

const formControlOverrides = {
  Label: {
    style: ({ $theme }: { $theme: Theme }) => ({
      fontSize: $theme.typography.LabelSmall.fontSize,
      marginBottom: 0,
    }),
  },
};

const DatepickerQuestionWrapper = ({
  supplementalQuestionPrompt,
  secondaryText,
  label,
  optional,
  errorMessage,
  placeholder,
  dataTest,
  ...datepickerProps
}: DatepickerQuestionWrapperProps) => {
  const { constructAriaLabel } = useConstructAriaLabel();

  const datepickerId = nextId(DATEPICKER_NAMESPACE);

  return (
    <div>
      {supplementalQuestionPrompt && (
        <PromptWithSecondaryText
          supplementalQuestionPrompt={supplementalQuestionPrompt}
          secondaryText={secondaryText}
          optional={optional}
          dataTest={dataTest}
        />
      )}
      <FormControl
        label="Date"
        htmlFor={datepickerId}
        error={errorMessage}
        overrides={formControlOverrides}
        dataTest={`${dataTest}-form-control`}
      >
        <Datepicker
          {...datepickerProps}
          inputAriaLabel={constructAriaLabel(
            supplementalQuestionPrompt,
            secondaryText,
            label,
            optional,
          )}
          placeholder={placeholder || "yyyy/mm/dd"}
          dataTest={dataTest}
          error={!!errorMessage}
        />
      </FormControl>
    </div>
  );
};

export default DatepickerQuestionWrapper;
